export default {
  // Page metadata
  'meta.title': 'सेवा की शर्तें - timer.today',
  'meta.description': 'timer.today ऑनलाइन टाइमिंग टूल प्लेटफ़ॉर्म के लिए सेवा की शर्तें और उपयोग समझौता। हमारे सेवा नियमों, उपयोगकर्ता अधिकारों और जिम्मेदारियों के बारे में जानें।',

  // Page header
  'page.title': 'सेवा की शर्तें',
  'page.lastUpdated': 'अंतिम अपडेट: {{date}}',
  'page.intro': 'timer.today में आपका स्वागत है। ये नियम और शर्तें timer.today की वेबसाइट के उपयोग के लिए नियमों और विनियमों की रूपरेखा तैयार करती हैं, जो timer.today पर स्थित है।',

  // Section 1
  'section1.title': '1. शर्तों की स्वीकृति',
  'section1.content': 'इस वेबसाइट तक पहुंचने और उसका उपयोग करने से, आप इस समझौते के नियमों और प्रावधानों को स्वीकार करते हैं और उनके लिए सहमत होते हैं। यदि आप उपरोक्त का पालन करने के लिए सहमत नहीं हैं, तो कृपया इस सेवा का उपयोग न करें।',

  // Section 2
  'section2.title': '2. सेवा विवरण',
  'section2.intro': 'timer.today निःशुल्क ऑनलाइन समय टूल प्रदान करता है जिसमें शामिल हैं:',
  'section2.timer': 'काउंटडाउन टाइमर - उत्पादकता, खाना पकाने और समय प्रबंधन के लिए अनुकूलन योग्य टाइमर',
  'section2.stopwatch': 'स्टॉपवॉच - खेल, प्रशिक्षण और सटीक समय के लिए उच्च-सटीक समय टूल',
  'section2.worldclock': 'विश्व घड़ी - वैश्विक समय क्षेत्रों का वास्तविक समय प्रदर्शन',

  // Section 3
  'section3.title': '3. उपयोग लाइसेंस',
  'section3.intro': 'timer.today को अस्थायी रूप से व्यक्तिगत, गैर-वाणिज्यिक क्षणिक देखने के लिए उपयोग करने की अनुमति दी गई है। यह एक लाइसेंस का अनुदान है, शीर्षक का हस्तांतरण नहीं, और इस लाइसेंस के तहत आप नहीं कर सकते:',
  'section3.item1': 'सामग्री को संशोधित या कॉपी करें',
  'section3.item2': 'किसी भी वाणिज्यिक उद्देश्य या किसी भी सार्वजनिक प्रदर्शन के लिए सामग्री का उपयोग करें',
  'section3.item3': 'वेबसाइट पर निहित किसी भी सॉफ़्टवेयर को रिवर्स इंजीनियर करने का प्रयास करें',
  'section3.item4': 'सामग्री से किसी भी कॉपीराइट या अन्य स्वामित्व सूचनाओं को हटाएं',

  // Section 4
  'section4.title': '4. गोपनीयता और डेटा',
  'section4.intro': 'timer.today आपकी गोपनीयता की रक्षा के लिए प्रतिबद्ध है:',
  'section4.item1': 'हम व्यक्तिगत जानकारी एकत्र या संग्रहीत नहीं करते हैं',
  'section4.item2': 'टाइमर सेटिंग्स आपके ब्राउज़र में स्थानीय रूप से संग्रहीत की जाती हैं',
  'section4.item3': 'हम उपयोगकर्ता व्यवहार या उपयोग पैटर्न को ट्रैक नहीं करते हैं',
  'section4.item4': 'ट्रैकिंग उद्देश्यों के लिए कोई कुकीज़ का उपयोग नहीं किया जाता है',

  // Section 5
  'section5.title': '5. अस्वीकरण',
  'section5.content': 'timer.today पर सामग्री \'जैसी है\' आधार पर प्रदान की जाती है। timer.today कोई वारंटी नहीं देता है, व्यक्त या निहित, और इसके द्वारा सभी अन्य वारंटी को अस्वीकार और नकारता है, जिसमें बिना सीमा के, निहित वारंटी या व्यापारिकता की शर्तें, किसी विशेष उद्देश्य के लिए फिटनेस, या बौद्धिक संपदा या अधिकारों के अन्य उल्लंघन का गैर-उल्लंघन शामिल है।',

  // Section 6
  'section6.title': '6. सीमाएं',
  'section6.content': 'किसी भी घटना में timer.today या इसके आपूर्तिकर्ता किसी भी नुकसान (डेटा या लाभ की हानि के लिए नुकसान सहित, बिना सीमा के, या व्यापार में रुकावट के कारण) के लिए उत्तरदायी नहीं होंगे, जो timer.today पर सामग्री के उपयोग या उपयोग में असमर्थता से उत्पन्न होते हैं, भले ही timer.today या इसके अधिकृत प्रतिनिधि को मौखिक या लिखित रूप में ऐसे नुकसान की संभावना के बारे में सूचित किया गया हो।',

  // Section 7
  'section7.title': '7. सामग्री की सटीकता',
  'section7.content': 'timer.today पर दिखाई देने वाली सामग्री में तकनीकी, टाइपोग्राफिकल या फोटोग्राफिक त्रुटियां शामिल हो सकती हैं। timer.today यह वारंटी नहीं देता है कि इसकी वेबसाइट पर किसी भी सामग्री सटीक, पूर्ण या वर्तमान है। timer.today बिना सूचना के किसी भी समय अपनी वेबसाइट पर निहित सामग्री में परिवर्तन कर सकता है।',

  // Section 8
  'section8.title': '8. संशोधन',
  'section8.content': 'timer.today बिना सूचना के किसी भी समय अपनी वेबसाइट के लिए इन सेवा की शर्तों को संशोधित कर सकता है। इस वेबसाइट का उपयोग करके, आप इन सेवा की शर्तों के तत्कालीन वर्तमान संस्करण से बंधे होने के लिए सहमत हैं।',

  // Section 9
  'section9.title': '9. संपर्क जानकारी',
  'section9.intro': 'यदि आपके पास इन सेवा की शर्तों के बारे में कोई प्रश्न हैं, तो कृपया हमसे संपर्क करें:',
  'section9.email': 'ईमेल:',
  'section9.emailSubject': 'सेवा की शर्तें पूछताछ - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. सर्वाधिकार सुरक्षित।'
};
